import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Cloudflare Pages preview of a release-web build. `active`: the build-<N>
 * alias still serves; `closed`: no deployment left (closed, or removed on
 * Publish); `unknown`: Hera has no Cloudflare credentials to check.
 */
export const ReleasePreviewSchema = z.object({
  url: z.string().url(),
  state: z.enum(['active', 'closed', 'unknown']),
});
export type ReleasePreview = z.infer<typeof ReleasePreviewSchema>;

const params = z.object({ releaseId: z.string().uuid() });

export const getReleasePreview = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/:releaseId/preview',
  params,
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleasePreviewSchema }),
});

export const closeReleasePreview = defineEndpoint({
  method: 'DELETE',
  path: '/v1/releases/:releaseId/preview',
  params,
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleasePreviewSchema }),
});
